import React from 'react';
import PropTypes from 'prop-types';
import { FormattedNumber } from 'react-intl';

import { CurrencySymbolContainer } from '../../../../../../../../containers/currency-symbol-container';
import style from '../edit-amount-summary-modal.module.less';

const ReadOnlyCurrencyColumn = ({ currencyValue }) => (
  <div className={style['read-only-currency']}>
    <CurrencySymbolContainer currencyCode={currencyValue.code} />
    <FormattedNumber value={currencyValue.value} />
  </div>
);

ReadOnlyCurrencyColumn.propTypes = {
  currencyValue: PropTypes.shape({
    code: PropTypes.string,
    value: PropTypes.number,
    disabled: PropTypes.bool,
  }).isRequired,
};

export { ReadOnlyCurrencyColumn };
